export default "__VITE_ASSET__DkbPaM82__"